import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { scale080, scale110, spaceL, spaceS, spaceXL } from '@xingternal/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';

export const JobSummaryContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const JobSummaryNotice = styled.div`
  width: 100%;
  order: 1;
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    order: 2;
    margin-bottom: 0;
    margin-top: ${spaceL};
  }
`;

export const JobSummaryContentBody = styled.div`
  width: 100%;
  order: 2;

  @media ${mediaConfined} {
    order: 1;
  }
`;

export const Introduction = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
`;

export const SectionHeader = styled(Headline)`
  margin-bottom: ${spaceL};
`;

// These styles match the ones used in the JDP content
export const JobSummaryList = styled.ul`
  margin-top: 0;
  margin-bottom: ${spaceXL};
  padding-inline-start: ${scale110};
`;

export const JobSummaryListItem = styled.li`
  font-size: ${scale080};
  margin-bottom: 1em;
  line-height: 1.65;
`;
